import * as React from "react";
import { IconProps } from "./IconProps";

export const IconDownload = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", ...props }, forwardedRef) => {
    return (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        ref={forwardedRef}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 3C12.5523 3 13 3.44772 13 4V12.0858L14.7929 10.2929C15.1834 9.90237 15.8166 9.90237 16.2071 10.2929C16.5976 10.6834 16.5976 11.3166 16.2071 11.7071L12.7071 15.2071C12.5196 15.3946 12.2652 15.5 12 15.5C11.7348 15.5 11.4804 15.3946 11.2929 15.2071L7.79289 11.7071C7.40237 11.3166 7.40237 10.6834 7.79289 10.2929C8.18342 9.90237 8.81658 9.90237 9.20711 10.2929L11 12.0858V4C11 3.44772 11.4477 3 12 3ZM4 14C4.55228 14 5 14.4477 5 15V19H19V15C19 14.4477 19.4477 14 20 14C20.5523 14 21 14.4477 21 15V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V15C3 14.4477 3.44772 14 4 14Z"
          fill={color}
        />
      </svg>
    );
  },
);
